import React from "react";
import {VisibilityRounded} from '@material-ui/icons';
import GenericLoadingIconButton, {IGenericLoadingIconButtonProps} from 'gui/components/genericLoadingIconButton';

interface IViewIconButtonProps extends Omit<IGenericLoadingIconButtonProps, "icon"> {
}

const ViewIconButton = (props: IViewIconButtonProps) => {
  return <GenericLoadingIconButton {...props} icon={VisibilityRounded}/>
};

ViewIconButton.defaultProps = {};

export default React.memo(ViewIconButton);
